import { action, payload } from 'ts-action'
import { ICalendarEvent } from 'models/CalendarEvent'
import { IError } from 'models/Global'

export const CalendarEventsFetching = action(
  'CalendarEventsFetching',
  payload<boolean>(),
)

export const GetCalendarEvents = action(
  'GetCalendarEvents',
  payload<ICalendarEvent[]>(),
)

export const GetCalendarEventsErrors = action(
  'GetCalendarEventsErrors',
  payload<IError>(),
)
